import { APIUtils } from '../../../utils/apiutils';
import httpClient from '../../../services/http';

export const medicinecategory = async () => {
    const res = await httpClient.get(APIUtils.getAPIEndpoint('medicinecategory'));
    return res.data;
};

export const getMedicineListByCategory = async (categoryId) => {
    const endpoint = APIUtils.getAPIEndpoint('medicinelistbycategory');
    console.log('endpoint',endpoint);
    const res = await httpClient.get(`${endpoint}/${categoryId}`);
    console.log('const res',res);
    return res.data;
};